export default __webpack_public_path__ + "static/media/navigate.6a28fa95.png";